import moment from 'moment';
import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { commonFields, teamsFields, scriptDatesFields, othersFields } from './constants';

export const createTimeInput = dateStr => {
    if (dateStr === '' || dateStr === null || dateStr === undefined || typeof dateStr === undefined) {
		return '';
	} else {
		if (dateStr === '0001-01-01T00:00:00') {
			return '';
		}
		return moment(dateStr).format('DD/MM/YYYY');
	}
};

export const fieldLengthValidation = field => (field.length > 200 ? { valid: false, message: 'Field too long' } : { valid: true });

export const formatNumericValue = cell => {
	let num = parseFloat(cell);
	return isNaN(num) ? `0.00` : `${num.toFixed(2)}`;
};

export const validateNumberValue = val => {
	//_checks isNAN and returns to set default value to cell.
	if (isNaN(val)) return { valid: true, message: '' };
	let num = parseFloat(val);
	if (num > 999.99) return { valid: false, message: `Maximum value is 999.99` };

	return { valid: true, message: '' };
};

export const booleanSelect = [
	{ label: '0 No', value: 'No' },
	{ label: '1 Yes', value: 'Yes' },
	{ label: '2 On Hold', value: 'On Hold' }
];

export const displayStatusSelect = [
	{ label: 'Pending', value: '0' },
	// {label: "2 Issued", value: "Issued"},
	{ label: 'Ready', value: '1' },
	{ label: 'On Hold', value: '2' }
];

export const amendmentReasonSelect = [
	{ label: ' Change of Meeting Venue', value: 'Change of Meeting Venue' },
	{ label: ' Change of Meeting Time', value: 'Change of Meeting Time' },
	{ label: ' Change of Meeting Date', value: 'Change of Meeting Date' },
	{
		label: ' Change of Script Allocation',
		value: 'Change of Script Allocation'
	},
	{ label: ' Change of Something Else', value: 'Change of Something Else' },
	{ label: ' Felt Like it', value: 'Felt Like it' },
	{ label: ' Just Because', value: 'Just Because' }
];

export const ConvertBooleanValueToYesOrNo = cell => {
	if (cell != null && !isNaN(cell)) {
		if (cell === 0) {
			return 'No';
		} else if (cell === 1) {
			return 'Yes';
		}
	} else return '';
};

export const setEditableAsPerArchive = (content, row, rowIndex, columnIndex) => {
	if (row.archive === 'Active') return true;
	else if (row.archive === 'Archived') return false;
};

export const templateFormatter = (cell, row, rowIndex, formatExtraData) => {
	if (!cell) return 'Not Set';
	else if (isNaN(cell)) return cell;
	else {
		//_Update template Id, name & set cell's text as per selected template from dropdown.
		let data = formatExtraData.templateData;
		let item = data.filter(obj => parseInt(obj.value) === parseInt(cell));
		if (typeof item !== 'undefined' && typeof item[0] !== 'undefined' && typeof item[0].label !== 'undefined') {
			row.templateId = item[0].value;
			row.templateName = item[0].label;
			return item[0].label;
		} else return 'Not Set';
	}
};

export const formatDateInput = dateStr => (dateStr === '' || dateStr === null || dateStr === undefined ? '' : moment(dateStr).format('DD/MM/YYYY'));

export const isTodayOrFuture = newValue => {
	if (newValue === null) {
		return true;
	}
	const newValueDate = newValue instanceof Date ? newValue : new Date(newValue);
	const newValueMs = newValueDate.getTime();
	const todayMs = new Date().setHours(0, 0, 0, 0);
	return newValueMs > todayMs;
};

export const validateReleaseDate = (newValue, row, column) => {
	let selectedDate = newValue;
	let currentDate = '',
		endDate = '',
		val = '',
		validateCurrentDate = true,
		validateReleaseDate = true;
	if (newValue) {
		val = moment(newValue).format('DD/MM/YYYY');
		currentDate = new Date();
		currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		selectedDate = new Date(newValue);
		selectedDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
		if (selectedDate < currentDate) validateCurrentDate = false;

		if (typeof row.contractEndDate !== 'undefined' && row.contractEndDate !== null && row.contractEndDate !== '') {
			endDate = new Date(row.contractEndDate);
			endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
			if (selectedDate > endDate) validateReleaseDate = false;
		}
	}
	if (!validateCurrentDate) {
		return {
			valid: false,
			message: `${val} should be current or future Date.`
		};
	} else if (!validateReleaseDate) {
		return {
			valid: false,
			message: `${val} should be less than or equal to End Date.`
		};
	}

	return { valid: true, message: '' };
};

export const validateEndDate = (newValue, row, column) => {
	let selectedDate = newValue;
	let currentDate = '',
		releaseDate = '',
		val = '',
		validateCurrentDate = true,
		validateEndDate = true;
	if (newValue) {
		val = moment(newValue).format('DD/MM/YYYY');
		currentDate = new Date();
		currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		selectedDate = new Date(newValue);
		selectedDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
		if (selectedDate < currentDate) validateCurrentDate = false;

		if (typeof row.contractReleaseDate !== 'undefined' && row.contractReleaseDate !== null && row.contractReleaseDate !== '') {
			releaseDate = new Date(row.contractReleaseDate);
			releaseDate = new Date(releaseDate.getFullYear(), releaseDate.getMonth(), releaseDate.getDate());
			if (selectedDate < releaseDate) validateEndDate = false;
		}
	}
	if (!validateCurrentDate) {
		return {
			valid: false,
			message: `${val} should be current or future Date.`
		};
	} else if (!validateEndDate) {
		return {
			valid: false,
			message: `${val} should be equal to or greater than Release Date.`
		};
	}

	return { valid: true, message: '' };
};

export const displayStatusFormatter = (cell, row) => {
	let status = row.hidStatus || '';
	if (!cell && status === '') return 'Not Set';
	else if (!cell && status !== '') {
		row.displayStatus = status;
		return status;
	} else return cell;
};

export const setStatusEditableAsPerIssued = (content, row, rowIndex, columnIndex) => (content && content === 'Issued' ? false : true);

export const formatName = (cell, row) => {
	const name = cell || '';
	if (row.lastUpdated) {
		const lastUpdated = moment(row.lastUpdated).format('DD/MM/YYYY HH:mm:ss');
		return (
			<>
				{name}
				<br />
				{lastUpdated}
			</>
		);
	} else {
		return name;
	}
};

export function getRefinerFields(activeScreen) {
    switch (activeScreen) {
        case 'teams':
            return [...commonFields, ...teamsFields];
		case 'scriptDates':
			return [...commonFields, ...scriptDatesFields];
        default:
            return [...commonFields, ...othersFields];
    }
}
